<template>
    <div class="home-page" style="height:100vh;">
		<Header></Header>
		<div class="content">
      <div class="nav flex">
      	<div class="back" @click="back">
      		<img src="static/images/return.png" />
      	</div>
      	<span class="">{{$t('language')}}</span>
      </div>
			<div class="information mt50">
        <div class="mission-t fs50 mt20">{{$t('language')}}</div>
        <div class="en-list mt100 fw7">
        	<div class="title2" :class="{'active':isShow=='en'}" @click="getLang(2,'en')"><img src="../../static/images/en.jpg">English</div>
        	<div class="title2" :class="{'active':isShow=='bur'}" @click="getLang(2,'bur')"><img src="../../static/images/en1.jpg">မြန်မာ</div>
        </div>
        <div class="ac mt100">
          <button class="btn btn-blue fw7" @click="getLang(1)">{{$t('change')}}</button>
        </div>
			</div>
		</div>
	</div>
</template>
<script>
import Header from '../components/headerNo'
export default {
    components:{
		Header
    },
    data() {
      return {
        list:[],
        lang:'',
        isShow:'bur',
      }
    },
	created(){
    if(localStorage.getItem('lang')){
      this.isShow = localStorage.getItem('lang')
    }
	},
    methods: {
      back(){
        this.$router.go(-1);
      },
      getLang(type,lang){
        if(type==1){
          localStorage.setItem('lang',this.lang)
          this.$router.push({path:'/index',query:{}});
          location.reload()
        }else{
          this.isShow = lang
          this.lang = lang
        }
      },
    }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/language.vue